import { FONT_FAMILY } from '../../../constants/styles';

export default {
  root: {
    fontFamily: FONT_FAMILY.primary,
    textTransform: 'initial',
    paddingLeft: 0,
    fontWeight: 400,
  },
  label: {
    fontSize: 14,
    lineHeight: 1.5,
    paddingLeft: 0,
  },
  appBar: {
    background: 'transparent',
    border: 0,
    boxShadow: 'none',
    flexFlow: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
};



// WEBPACK FOOTER //
// ./src/components/common/CommonTabs/materialStyles.js